const SET_LANG = "SET_LANG";
const UPDATE_TIME = "UPDATE_TIME";
const LOAD = "LOAD";
const REFRESH_SASTOKEN = "REFRESH_SASTOKEN";

export {
    SET_LANG,
    UPDATE_TIME,
    LOAD,
    REFRESH_SASTOKEN,
};
